import React from 'react';
import styled from 'styled-components';
import {
	CircularProgressbar,
	CircularProgressbarWithChildren,
	buildStyles,
} from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';

const GaugeStyle = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	position: relative;
	background: ${props => props.theme.Cool_Gray_Light_3};
	&.small {
		.gauge-top {
			height: 57px;
		}
		.circle {
			width: 94px;
			height: 94px;
			bottom: 5px;
			left: 2px;
		}
		.text {
			width: 50px;
			bottom: 0px;
			left: 24px;
		}
	}
	.gauge-top {
		z-index: 1000;
		width: 100%;
		height: 112px;
		overflow: hidden;
		position: absolute;
		background: ${props => props.theme.Cool_Gray_Light_3};
		top: 0;
	}
	.circle {
		z-index: 100;
		width: 186px;
		height: 170px;
		border-top-right-radius: 100%;
		border-top-left-radius: 100%;
		border-bottom-right-radius: 100%;
		border-bottom-left-radius: 100%;
		border: 1px solid grey;
		position: absolute;
		bottom: 5px;
		left: 7px;
	}
	.text {
		z-index: 150;
		position: absolute;
		bottom: 3px;
		left: 65px;
		width: 70px;
		background: ${props => props.theme.Cool_Gray_Light_3};
		text-align: center;
	}
	.display-text {
		z-index: 2000;
		display: flex;
		.sub-text {
			display: flex;
			font-size: 14px;
			.unit {
				margin-left: 5px;
			}
		}
	}

	@media screen and (min-width: ${props => props.theme.res.medium}) and (max-width: ${props =>
			props.theme.res.high}) {
		&.small {
			.gauge-top {
				height: 84px;
			}
			.circle {
				width: 141px;
				height: 133px;
				bottom: 5px;
				left: 5px;
			}
			.text {
				width: 60px;
				bottom: 0px;
				left: 43px;
			}
		}
		.gauge-top {
			height: 165px;
		}
		.circle {
			width: 283px;
			height: 266px;
			bottom: 5px;
			left: 8px;
		}
		.text {
			width: 120px;
			bottom: 3px;
			left: 86px;
		}
		.display-text {
			.sub-text {
				font-size: 14px;
				.unit {
					margin-left: 5px;
				}
			}
		}
	}

	@media screen and (min-width: ${props => props.theme.res.high}) {
		&.small {
			.gauge-top {
				height: 84px;
			}
			.circle {
				width: 141px;
				height: 133px;
				bottom: 5px;
				left: 5px;
			}
			.text {
				width: 60px;
				bottom: 0px;
				left: 43px;
			}
		}
		.gauge-top {
			height: 165px;
		}
		.circle {
			width: 279px;
			height: 266px;
			bottom: 5px;
			left: 9px;
		}
		.text {
			width: 120px;
			bottom: 3px;
			left: 86px;
		}
		.display-text {
			.sub-text {
				font-size: 14px;
				.unit {
					margin-left: 5px;
				}
			}
		}
	}
`;

export const Gauge = ({ id, cypressId, pathColor1, pathColor2, status, size }) => {
	return (
		<GaugeStyle id={id} data-cy={cypressId} className={`power-trends  ${size}`}>
			<div className={`gauge-top`}>
				<CircularProgressbarWithChildren
					value={75}
					styles={buildStyles({
						pathColor: pathColor1,
						trailColor: 'transparent',
						rotation: 0.75,
						textSize: 14,
					})}
					circleRatio={0.5}
					strokeWidth={6}
					//background={true}
				>
					<CircularProgressbar
						value={18}
						circleRatio={0.5}
						styles={buildStyles({
							trailColor: 'transparent',
							pathColor: pathColor2,
							rotation: 0.25,
						})}
						counterClockwise
						strokeWidth={6}
					/>
				</CircularProgressbarWithChildren>
			</div>
			<div className='circle'></div>
			<div className='text body10'>{status}</div>
			<div className='display-text'>
				<div className='main-text numbers30'>5</div>
				<div className='sub-text'>
					<div className='number numbers20'>.0</div>
					<div className='unit body10'>kWH</div>
				</div>
			</div>
		</GaugeStyle>
	);
};
